import { css } from '@emotion/css';
import { Button, Select, Space, Typography } from 'antd';
import { useTranslate } from '@tolgee/react';

const PAGE_SIZE_OPTIONS = [20, 50, 100, 200];

const barClassName = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  .scope-pagination-size {
    width: 88px;
  }

  .scope-pagination-number {
    width: 88px;
  }
`;

export interface ScopePaginationProps {
  pageNo: number;
  pageSize: number;
  total: number;
  hasNext: boolean;
  disabled?: boolean;
  onPageChange: (page: number) => void;
  /** 切换每页条数后由父级回到第 1 页 */
  onPageSizeChange: (pageSize: number) => void;
}

/** 商品选品分页条（对齐 perseus：页码信息 + 每页条数 + 上一页/页码/下一页） */
export function ScopePagination({
  pageNo,
  pageSize,
  total,
  hasNext,
  disabled = false,
  onPageChange,
  onPageSizeChange,
}: ScopePaginationProps) {
  const { t } = useTranslate();
  const pages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className={barClassName}>
      <Typography.Text type="secondary">
        {t('productKnowledge_mapping_page', { page: pageNo, pages, total })}
      </Typography.Text>
      <Space>
        <Select
          className="scope-pagination-size"
          aria-label={t('productKnowledge_mapping_page_size')}
          value={pageSize}
          disabled={disabled}
          onChange={(size: number) => onPageSizeChange(size)}
          options={PAGE_SIZE_OPTIONS.map((size) => ({
            value: size,
            label: `${size}`,
          }))}
        />
        <Button disabled={disabled || pageNo <= 1} onClick={() => onPageChange(pageNo - 1)}>
          {t('productKnowledge_common_previous_page')}
        </Button>
        <Select
          className="scope-pagination-number"
          aria-label={t('productKnowledge_mapping_page_number')}
          value={pageNo}
          disabled={disabled}
          onChange={(page: number) => onPageChange(page)}
          options={Array.from({ length: pages }, (_, index) => ({
            value: index + 1,
            label: `${index + 1}`,
          }))}
        />
        <Button disabled={disabled || !hasNext} onClick={() => onPageChange(pageNo + 1)}>
          {t('productKnowledge_common_next_page')}
        </Button>
      </Space>
    </div>
  );
}
